/**
 *
 * Created By Arokoyu Olalekan Ojo <olalekan.arokoyu@upperlink.ng> @ 30/05/2018
 *
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs-compat/Observable';
import {isNullOrUndefined} from 'util';
import {HttpClient, HttpHeaders, HttpResponse, HttpParams} from '@angular/common/http';
import { environment as env } from '../../../environments/environment';

@Injectable()
export class RestfulHttpService {
  token: string;
  options: any;
  headers_: any = {};
  constructor(private http: HttpClient) {
    // this.token  = env.TOKEN;
  }

  /**
   *
   */
 /* createAuthorizationHeader() {
    // console.log('Token Auth ', sessionStorage.getItem(this.token), 'token 2 ', this.token);
    if (!isNullOrUndefined(sessionStorage.getItem(this.token))) {
      this.headers_ = new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': sessionStorage.getItem(this.token)
      });
    } else {
      this.headers_ = new HttpHeaders({
        'Content-Type':  'application/json'
      });
    }
  }*/

  /**
   * A Restful Http get request.
   * @param {string} endpoint
   * @param {HttpParams} parameters
   * @returns {Observable<HttpResponse>}
   */
  public get(endpoint: string, parameters?: HttpParams): Observable<any> {
    // console.info('HEADER::', this.headers_);
    // this.createAuthorizationHeader();

    if (parameters) {
      this.options = { params: parameters, headers: this.headers_ };
    } else {
      this.options = { headers: this.headers_ };
    }
    return this.http.get(endpoint, this.options);
  }


  /**
   * A Restful Http post request.
   * @param {string} endpoint
   * @param data
   * @returns {Observable<HttpResponse>}
   */
  public post(endpoint: string, data: any): Observable<any> {
    // this.createAuthorizationHeader();
    return this.http.post(endpoint, data, {  headers: this.headers_ });
  }


  /**
   * A Restful Http delete Request.
   * @param {string} endpoint
   * @param data
   * @returns {Observable<HttpResponse>}
   */
  public delete(endpoint: string , data: any): Observable<any> {
    // this.createAuthorizationHeader();
    const params = new HttpParams(data);
    return this.http.delete(endpoint, {headers: this.headers_, params: params});

  }


  /**
   * A Restful Http put request.
   * @param {string} endpoint
   * @param data
   * @returns {Observable<HttpResponse>}
   */
  public put(endpoint: string, data: any): Observable<any> {
    // this.createAuthorizationHeader();
    return this.http.put(endpoint, data, {  headers: this.headers_ });
  }


  /**
   * A Restful Http patch request
   * @param {string} endpoint
   * @param data
   * @returns {Observable<HttpResponse>}
   */
  public patch(endpoint: string, data: any): Observable<any> {
    // this.createAuthorizationHeader();
    return this.http.patch(endpoint, data, {  headers: this.headers_ });
  }

  reRouteBaseUrl(method, api): string {
    let endpoint;
    // console.log('SLIPPING >> ', env.API_URL.split(env.IP.first));
    let BASE = window.location.protocol + '//' + window.location.host + '/edms/public/index.php/api';
    // console.log(window.location.host);
    if (window.location.host.toString() === `localhost:5200` || window.location.host.toString() === `edms-test.uplsv.com.ng`) {
      BASE = env.API_URL;
    } else if ( window.location.host.toString() === `127.0.0.1:8081` || window.location.host.toString() === `127.0.0.1:8443` ) {
      BASE = `https://edms.odunitan.com/api`;
    }
    // console.log('BASES >>>> ', BASE);
    if (!isNullOrUndefined(method)) {
      endpoint = BASE + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      endpoint = BASE + '/' + env.API_VERSION + '/' + api;
    }
    console.log(endpoint);
    return  endpoint;
  }
}
